import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What are the major applications of genetic engineering?",
    category: "Technology",
    description:
      "Genetic engineering is used in medicine, agriculture, biotechnology, pharmaceuticals, and research. Applications include disease treatments, GM crops, vaccines, gene therapy, insulin production, and developing organisms with enhanced beneficial traits.",
  },
  {
    title: "What career opportunities exist in genetic engineering?",
    category: "Trending",
    description:
      "Careers include Genetic Engineer, Research Scientist, Biotechnologist, Molecular Biologist, Lab Technician, Bioinformatics Specialist, Clinical Researcher, and Pharmaceutical Scientist. These roles exist across healthcare, agriculture, biotech firms, and research laboratories.",
  },
  {
    title: "What skills are needed to become a genetic engineer?",
    category: "Design",
    description:
      "Genetic engineers need strong molecular biology knowledge, lab handling skills, PCR techniques, DNA editing experience, data analysis, and understanding of gene expression. Basic coding and bioinformatics skills also strengthen career opportunities.",
  },
  {
    title: "What industries hire genetic engineers?",
    category: "Design",
    description:
      "Industries include pharmaceuticals, biotech companies, agriculture, genomics labs, forensic labs, food technology firms, and medical research centers. Growing demand for genetic solutions increases hiring across multiple sectors.",
  },
  {
    title: "What laboratory skills are important in genetic engineering?",
    category: "Design",
    description:
      "Important skills include DNA extraction, PCR, gel electrophoresis, pipetting, sterile culture handling, plasmid preparation, and microscopy. Mastering these techniques is essential for accurate molecular experiments.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
